import { isEmpty } from 'lodash/fp';

import { CmsInsuranceTypeContent } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';

type Props = {
  cmsSectionContent?: CmsInsuranceTypeContent['contactDetails'] | null;
};

const mapContactDetailsContent = ({ cmsSectionContent }: Props) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  return {
    ...cmsSectionContent,
    type: CONTENT_SECTIONS.CONTACT_DETAILS,
  };
};

export default mapContactDetailsContent;
